const STORY_LIST_AD_FIRST_POSITION = 5;
const STORY_LIST_AD_REPEAT_INTERVAL = 10;

export const showAd = (index: number) => {
  if (index + 1 === STORY_LIST_AD_FIRST_POSITION) return true;

  if (index + 1 < STORY_LIST_AD_REPEAT_INTERVAL) return false;

  if (
    (index + 1 - STORY_LIST_AD_FIRST_POSITION) %
      STORY_LIST_AD_REPEAT_INTERVAL ===
    0
  )
    return true;

  return false;
};
